"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stripHtml = void 0;

const stripHtml = value => typeof value === 'string' ? value.replace(/<[^>]+>/g, '') : value;

exports.stripHtml = stripHtml;